<template>
  <v-card v-if="bidCostType" id="bid-cost-type-form">
    <v-card-title class="primary white--text">
      <v-row class="pa-2" justify="space-between">
        <span class="headline">
          {{ title }}
        </span>
        <BaseDialogActions hideRefresh hideFullscreen />
      </v-row>
    </v-card-title>
    <v-card-text class="text-right">
      <v-text-field
      class="py-6"
      v-model="bidCostType.name"
      :rules="[rules.required]"
      :label="$t('name')"
      color="black"
      :counter="maxNameLength"
      :maxlength="maxNameLength"
      ref="bidCostTypeName"/>
      <v-btn id="bid-cost-type-submit" color="primary" @click="submitClicked" :disabled="!canSubmit">
        {{ buttonText }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import fieldRules from '@/utils/rules.js'
import { StringConstants } from '@/utils/constants'

export default {
  name: 'BidCostTypeForm',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    propBidCostType: {
      type: Object,
      required: false,
      default: undefined
    }
  },

  created () {
    if (this.propBidCostType) {
      this.bidCostType = cloneDeep(this.propBidCostType)
    }
  },

  mounted () {
    setTimeout(_ => {
      this.$refs.bidCostTypeName.focus()
      document.addEventListener('keyup', this.onKeyup)
    }, 0)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.onKeyup)
  },

  computed: {
    editing () {
      return this.bidCostType?.bidCostTypeId
    },

    title () {
      return this.editing ? this.$t('editBidCostType') : this.$t('createNewBidCostType')
    },

    buttonText () {
      return this.editing ? this.$t('saveChanges') : this.$t('create')
    },

    canSubmit () {
      return this.bidCostType.name.length > 0 && this.bidCostType.name.length <= this.maxNameLength
    }
  },

  data: () => ({
    bidCostType: {
      name: ''
    },
    maxNameLength: StringConstants.MediumStringLength,
    rules: fieldRules.rules
  }),

  methods: {
    ...mapActions('tract', ['createBidCostType', 'updateBidCostType']),

    async submitClicked () {
      if (this.canSubmit) {
        this.editing ? await this.updateBidCostType(this.bidCostType) : await this.createBidCostType(this.bidCostType)
        this.$emit('bid-cost-type-mutated')
      } else {
        this.setSnackError(this.$t('nameIsRequired'))
      }
    },

    onKeyup (e) {
      if (e.key.toLowerCase() === 'enter') {
        this.submitClicked()
      }
    }
  }
}
</script>
